import React, { useState, useRef, useEffect } from "react";
import { MdCheck, MdContentCopy, MdShare } from "react-icons/md";
import ModalSendCode from "../ModalSendCode";

export default function MeetInputForCode({
  code,
  textColor,
  message,
  displayCopy,
  handleCopy,
  setDisplayCopy,
}) {
  const [showCodeOrLink, setShowCodeOrLink] = useState(false);

  return (
    <>
      <div
        style={{
          position: "relative",
        }}
      >
        <marquee>
          <label className="form-label" htmlFor={code}>
            <h6
              className={message.length > 0 ? `text-success` : ""}
              style={{ color: textColor }}
            >
              {message !== ""
                ? message
                : "Copiez et transférez le code de la réunion."}
            </h6>
          </label>
        </marquee>
        {!displayCopy ? (
          <MdContentCopy
            style={{
              position: "absolute",
              color: textColor,
              top: "36px",
              left: "8px",
              zIndex: 2,
              fontSize: "25px",
            }}
            onClick={() => {
              handleCopy(code);
              setDisplayCopy(true);
            }}
          />
        ) : (
          <MdCheck
            style={{
              position: "absolute",
              color: "#00b074",
              top: "36px",
              left: "8px",
              zIndex: 2,
              fontSize: "25px",
            }}
          />
        )}
        <MdShare
          onClick={() => setShowCodeOrLink(true)}
          style={{
            position: "absolute",
            color: textColor,
            top: "36px",
            right: "8px",
            zIndex: 2,
            fontSize: "25px",
          }}
        />
        <input
          className="w-100"
          value={code}
          id={code}
          readOnly={true}
          style={{
            height: "2.4rem",
            borderRadius: "0.2rem",
            color: textColor,
            backgroundColor: "transparent",
            cursor: "pointer",
            fontSize: "1.2rem",
            textAlign: "center",
            position: "relative",
            border: "1px solid #fff",
          }}
        />
      </div>
      {showCodeOrLink && (
        <ModalSendCode
          setShowCodeOrLink={setShowCodeOrLink}
          showCodeOrLink={showCodeOrLink}
          accessCode={code}
        />
      )}
    </>
  );
}
